module.exports = __webpack_public_path__ + "img/1475844469.caf3688a.jpg";